import posthog from 'posthog-js';
import type {
  UserEntity,
} from '@dinosave/core/types';

const init = () => {
  if (
    import.meta.env.DEV === true
  ) return;

  return posthog.init(
    import.meta.env.PUBLIC_ENV__POSTHOG_KEY,
    {
      api_host: import.meta.env.PUBLIC_ENV__POSTHOG_HOST,
      capture_pageview: false,
    },
  );
};

const identify = (user: UserEntity) => {
  if (
    !user?.uuid
  ) return;

  const options = {
    name: user?.name,
    email: user?.email,
  };

  return posthog.identify(user.uuid, options);
};

const client = {
  init,
  identify,
  capture: posthog.capture,
  events: {
    ITEM_URL_PARSING: 'item_url_parsing',
    ITEM_URL_HTML_RECEIVED: 'item_url_html_received',
    ITEM_URL_HTML_PARSED: 'item_url_html_parsed',
    ITEM_URL_DATA_SCRAPED: 'item_url_data_scraped',
    ITEM_URL_IMAGE_PARSED: 'item_url_image_parsed',
    ITEM_URL_PARSING_FAILED: 'item_url_parsing_failed',
    ITEM_SAVED: 'item_saved',
  },
};

export default client;
